import { render } from "./LocalDefinitionIcon.vue?vue&type=template&id=3f04f4a8&ts=true"
import script from "./LocalDefinitionIcon.vue?vue&type=script&lang=ts"
export * from "./LocalDefinitionIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__